<template>
<div class="form-group" :data-id="fieldName" :class="{ 'l_wide' : isMulti, 'l_half' : isHalf }" @keydown.esc="closeDropdown">
  <div class="form-control">
    <div class="dropdown" :class="{ 'l_multi' : isMulti, 's_open' : isOpen, 's_active' : !isEmpty }">
      <button type="button" class="dropdown-btn" @click="toggleDropdown"  v-bind:key="fieldName" :tabindex="tabIndex">
        <div class="dropdown-label">{{ labelText }}</div>
      </button>
      <div class="dropdown-content">
        <div class="dropdown-opts">
          <button type="button" class="dropdown-opt l_stretch" :class="{ 's_active' : isEmpty }" @click="selectAll($event)" :tabindex="tabIndexOpt">
            <svg class="icon"><use xlink:href="#check"></use></svg>
            <span v-html="placeholder"></span>
            <div v-if="isMulti" style="display: none;">
              <input type="checkbox" :name="`${fieldName}[]`" :id="`${formId}_${fieldName}_empty`" value="" v-model="isEmpty">
            </div>
          </button>
          <button type="button" v-for="(opt, index) in liveOptions" v-bind:key="index" class="dropdown-opt" :class="['l_' + opt.color, { 's_active' : liveOptions[index].selected }]" @click="toggleSelect($event, index)" :tabindex="tabIndexOpt">
            <svg class="icon"><use xlink:href="#check"></use></svg>
            <span>{{ opt.name }}</span>
            <div v-if="isMulti" style="display: none;">
              <input type="checkbox" :name="`${fieldName}[]`" :id="`${formId}_${fieldName}_${index}`" :value="opt.id" v-model="liveOptions[index].selected">
            </div>
          </button>
        </div>
        <input type="hidden" v-if="!isMulti" :name="fieldName" v-model="fieldVal">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import EventBus from '../utils/event-bus';
export default {
  name: "Selector",
  data() {
    return {
      isOpen: false,
      // isEmpty: true,
      liveOptions: this.options,
      // selectedOptions: [],
      searchDisplay: false,
      searchAdvanced: false,
    };
  },
  props: {
    options: Array,
    formId: String,
    fieldLabel: String,
    fieldName: String,
    placeholder: {
      type: String,
      default: 'All'
    },
    isMulti: {
      type: Boolean,
      default: false
    },
    isHalf: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function() { return []; }
    },
    searchId: {
      type: String,
      default: 'main'
    },
    isAdvanced: {
      type: Boolean,
      default: false
    },
  },
  computed: {

    isEmpty: function() {
      if (this.selectedOptions.length == 0) {
        return true;
      }
      return false;
    },

    tabIndex: function() {
      if (this.searchId == 'mega') {
        if (this.searchDisplay) {
          return '0';
        } else {
          return '-1';
        }
      } else if (this.isAdvanced) {
        if (this.searchAdvanced) {
          return '0';
        } else {
          return '-1';
        }
      } else {
        return '0';
      }
    },

    tabIndexOpt: function() {
      if (this.isOpen) {
        return '0';
      } else {
        return '-1';
      }
    },

    selectedOptions: function() {
      return this.liveOptions.filter(opt => opt.selected);
    },

    fieldVal: {

      get: function () {
        if (this.selectedOptions.length) {
          // console.log(this.selectedOptions[0].id);
          return this.selectedOptions[0].id;
        }
        return '';
      },

      set: function (newValue) {
      }

    },

    labelText: function() {
      var theLabel = '';
      var sep = '';
      var maxChars = 23;
      // if (this.selectedOptions.length > 5) {
      //   theLabel += this.selectedOptions.length + ' selected';
      // } else
      if (this.selectedOptions.length) {
        for (var i = 0; i < this.selectedOptions.length; i++) {
          var newLabel = theLabel + sep + this.selectedOptions[i]['name'];
          if (newLabel.length <= maxChars) {
            theLabel += sep + this.selectedOptions[i]['name'];
          } else {
            theLabel += ' + ' + (this.selectedOptions.length - i) + ' more';
            break;
          }
          sep = ', ';
        }
      } else {
        theLabel = this.fieldLabel;
      }
      return theLabel;
    }

  },
  methods: {

    toggleDropdown(e) {
      if (!this.isOpen) {
        EventBus.$emit('SELECTOR_CLOSEALL');
      }
      this.isOpen = !this.isOpen;
      e.preventDefault();
      return false;
    },

    closeDropdown(e) {
      this.isOpen = false;
      e.preventDefault();
      return false;
    },

    toggleSelect(e, optIndex) {
      if (!this.isMulti) {
        for (var i = 0; i < this.liveOptions.length; i++) {
          this.$set(this.liveOptions[i], 'selected', false);
        }
        this.toggleDropdown(e);
      }
      this.liveOptions[optIndex]['selected'] = !this.liveOptions[optIndex]['selected'];
      EventBus.$emit('SEARCH_UPDATE', this.fieldName, this.selectedOptions);
      e.preventDefault();
      return false;
    },

    selectAll(e) {
      if (!this.isMulti) {
        this.toggleDropdown(e);
      }
      for (var i = 0; i < this.liveOptions.length; i++) {
        this.$set(this.liveOptions[i], 'selected', false);
      }
      EventBus.$emit('SEARCH_UPDATE', this.fieldName, this.selectedOptions);
      e.preventDefault();
      return false;
    },

  },
  // directives: {
  //   clickOutside: {
  //     // directive definition
  //     bind: function (el, binding, vnode) {
  //       el.clickOutsideEvent = function (event) {
  //         // here I check that click was outside the el and his childrens
  //         if (!(el == event.target || el.contains(event.target))) {
  //           // and if it did, call method provided in attribute value
  //           vnode.context[binding.expression](event);
  //         }
  //       };
  //       document.body.addEventListener('click', el.clickOutsideEvent)
  //     },
  //     unbind: function (el) {
  //       document.body.removeEventListener('click', el.clickOutsideEvent)
  //     },
  //   }
  // },
  mounted() {

    EventBus.$on('SEARCH_DISPLAY_UPDATE', (searchDisplay) => {
      this.searchDisplay = searchDisplay;
    });

    EventBus.$on('SEARCH_ADVANCED_UPDATE', (searchAdvanced) => {
      this.searchAdvanced = searchAdvanced;
    });

    EventBus.$on('SELECTOR_CLOSEALL', () => {
      this.isOpen = false;
    });

    EventBus.$on('SEARCH_CLEAR', () => {
      for (var i = 0; i < this.liveOptions.length; i++) {
        this.$set(this.liveOptions[i], 'selected', false);
      }
      EventBus.$emit('SEARCH_UPDATE', this.fieldName, this.selectedOptions);
    });

    // set default of each option
    for (var i = 0; i < this.liveOptions.length; i++) {
      var isSelected = false;
      if (this.selected.includes(this.liveOptions[i]['id'])) {
        isSelected = true;
      }
      this.$set(this.liveOptions[i], 'selected', isSelected);
    }

    // update global search
    setTimeout(() => EventBus.$emit('SEARCH_UPDATE', this.fieldName, this.selectedOptions), 100);

  }
};
</script>

<style scoped>
</style>